import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AUTH_SESSION_HANDLER, AuthInterceptor, ErrorInterceptor, provideApiBaseUrl } from 'shared';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';
import { AppComponent } from './app-root/app.component';
import { AppRoutingModule } from './app-routing.module';
import { AuthModule } from './auth/auth.module';
import { CartModule } from './cart/cart.module';
import { CatalogModule } from './catalog/catalog.module';
import { CheckoutModule } from './checkout/checkout.module';
import { HomeModule } from './home/home.module';
import { SearchModule } from './search/search.module';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    HomeModule,
    CatalogModule,
    SearchModule,
    AuthModule,
    CartModule,
    CheckoutModule
  ],
  bootstrap: [AppComponent],
  providers: [
    provideApiBaseUrl(environment.apiUrl),
    { provide: AUTH_SESSION_HANDLER, useExisting: AuthService },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
  ]
})
export class AppModule {}
